import { CoverageErrorType, IBestTech } from '@vfit/shared/models';
import { useCoverageToolModalProvider } from '../coverageToolModal.context';
import { useCoverageToolFw, useCoverageToolVf, useCoverageToolVfFw } from '@vfit/consumer/hooks';

export const useCoverageToolFlow = (): {
  isLoading: boolean;
  isSuccess: boolean;
  isError: boolean;
  errorType: CoverageErrorType;
  bestTech?: IBestTech;
} => {
  const { product, offerId, address, isAddressConfirmed, coverageToolFlowType } =
    useCoverageToolModalProvider();
  const {
    isLoading: isLoadingCoverageToolVf,
    isSuccess: isSuccessCoverageToolVf,
    isError: isErrorCoverageToolVf,
    errorType: errorTypeCoverageToolVf,
  } = useCoverageToolVf({
    product,
    offerId,
    address,
    isAddressConfirmed: isAddressConfirmed && coverageToolFlowType === 'STANDARD',
  });
  const {
    isLoading: isLoadingCoverageToolVfFw,
    isSuccess: isSuccessCoverageToolVfFw,
    isError: isErrorCoverageToolVfFw,
    errorType: errorTypeCoverageToolVfFw,
    bestTech: bestTechVfFw,
  } = useCoverageToolVfFw({
    product,
    offerId,
    address,
    isAddressConfirmed: isAddressConfirmed && coverageToolFlowType === 'AMDOCS_FW',
  });
  const {
    isLoading: isLoadingCoverageToolFw,
    isSuccess: isSuccessCoverageToolFw,
    isError: isErrorCoverageToolFw,
    errorType: errorTypeCoverageToolFw,
    bestTech: bestTechFw,
  } = useCoverageToolFw({
    product,
    offerId,
    address,
    isAddressConfirmed: isAddressConfirmed && coverageToolFlowType === 'FASTWEB',
  });

  const getResponse = () => {
    switch (coverageToolFlowType) {
      case 'STANDARD':
        return {
          isLoading: isLoadingCoverageToolVf,
          isSuccess: isSuccessCoverageToolVf,
          isError: isErrorCoverageToolVf,
          errorType: errorTypeCoverageToolVf,
        };
      case 'AMDOCS_FW':
        return {
          isLoading: isLoadingCoverageToolVfFw,
          isSuccess: isSuccessCoverageToolVfFw,
          isError: isErrorCoverageToolVfFw,
          errorType: errorTypeCoverageToolVfFw,
          bestTech: bestTechVfFw,
        };
      case 'FASTWEB':
        return {
          isLoading: isLoadingCoverageToolFw,
          isSuccess: isSuccessCoverageToolFw,
          isError: isErrorCoverageToolFw,
          errorType: errorTypeCoverageToolFw,
          bestTech: bestTechFw,
        };
    }
  };

  return getResponse();
};
